//
//
//
//
//
//
//
//
//
//
//
import DeviceInfoList from "./DeviceInfoList";
export default {
  components: {
    DeviceInfoList: DeviceInfoList
  },
  data: function data() {
    return {
      tabKeys: "2"
    };
  },
  created: function created() {
    this.tabKeys = "2";
  },
  computed: {},
  methods: {}
};